export const ACCOUNT_QUICK_LINKS_PANEL_TEST_ID = 'qa-account-quick-links'

/** Zero-layout wrapper for the pubsub-controlled QuickLinks MFE slot */
export const ACCOUNT_QUICK_LINKS_PANEL_WRAPPER_CLASS = 'account-quick-links-panel-host'
